import { createImageUrlBuilder } from "@sanity/image-url";

export const projectId = import.meta.env.VITE_SANITY_PROJECT_ID || "bejzbcu2";
export const dataset = import.meta.env.VITE_SANITY_DATASET || "production";

// Create a lightweight builder configuration without the full client
const builder = createImageUrlBuilder({
    projectId,
    dataset,
});

type SanityImageSource = Parameters<typeof builder.image>[0];

export function urlFor(source: SanityImageSource) {
    return builder.image(source);
}
